export default "__VITE_ASSET__CECUlyL3__"